import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Call Us',
  description: 'Reach out to our friendly dispatch team. We will listen to your issue and schedule a convenient time.'
}, {
  number: '02',
  title: 'We Diagnose',
  description: 'Our expert plumber arrives on time, inspects the problem, and provides a clear, upfront quote.'
}, {
  number: '03',
  title: 'Done Right',
  description: 'We complete the repair or installation efficiently, clean up our workspace, and ensure you are satisfied.'
}];
export function Process() {
  return <section className="py-24 bg-brand-navy text-white relative overflow-hidden" data-id="element-197">
      {/* Background Image Texture */}
      <div className="absolute inset-0 z-0 opacity-10 mix-blend-overlay" data-id="element-198">
        <img src="https://images.unsplash.com/photo-1585704032915-c3400ca199e7?q=80&w=2070&auto=format&fit=crop" alt="Plumbing pipes texture" className="w-full h-full object-cover" data-id="element-199" />
      </div>

      {/* Abstract Background Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-dark rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/3 z-0" data-id="element-200"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-red/20 rounded-full blur-3xl opacity-50 translate-y-1/2 -translate-x-1/3 z-0" data-id="element-201"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-202">
        <div className="text-center mb-16" data-id="element-203">
          <h2 className="text-brand-red font-bold tracking-widest uppercase text-sm mb-3" data-id="element-204">
            How It Works
          </h2>
          <h3 className="text-4xl md:text-5xl font-display font-bold uppercase" data-id="element-205">
            Our Simple Process
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-206">
          {/* Connecting Line (Desktop only) */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-white/10 z-0" data-id="element-207"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-208">
              <div className="w-24 h-24 bg-brand-navy border-4 border-brand-red rounded-full flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(200,16,46,0.3)]" data-id="element-209">
                <span className="text-3xl font-display font-bold text-white" data-id="element-210">
                  {step.number}
                </span>
              </div>
              <h4 className="text-2xl font-display font-bold uppercase mb-4" data-id="element-211">
                {step.title}
              </h4>
              <p className="text-gray-300 leading-relaxed max-w-xs" data-id="element-212">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}